import React from 'react'
import { useLocation } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router'
import { useState } from 'react';
import { webinar } from "../../service/webinarsService"
import { useContext } from 'react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom'


const AfterBuy = () => {
    const location = useLocation()
    const state = useParams().state
    const [getWebinar, setWebinar] = useState("")
    const [getSearchParams, setSearchParams] = useSearchParams();


    const productParams = getSearchParams.get("product")
    const slugParams = getSearchParams.get("slug")


    const handleGetWebinars = async (slug) => {
        try {
            const { status, data } = await webinar(slug);
            if (status === 200) {
                setWebinar(data.webinar)
            }
        }
        catch (ex) {
        }
    }
    const handleGoToGroupLink = (link) => {
        window.location = link
    }
    useEffect(()=>{
        handleGetWebinars(slugParams)
    })
    return (
        <>
            {state == "ok" ? (
                <>
                    <div className='after-buy ok'>
                        <i className='fa fa-check'></i>
                        <span>خرید با موفقیت انجام شد</span>
                    </div>
                    {productParams == 'registerWebinar' ? (
                        <div className='group'>
                        جهت دریافت لینک کلاس به آیدی زیر در تلگرام یا سروش یا روبیکا پیام دهید:
                       new_webinar@
                   </div>
                    ) : null}
                    {productParams == 'BuyWebinar' ? (
                        <div className='group'>
                        جهت مشاهده فایل های دوره به  ثبت نام مراجعه کنید
                   </div>
                    ) : null}

                    
                </>
            ) : (
                <div className='after-buy nok'>
                    <i className='fas fa-plus'></i>
                    <span>خرید انجام نشد</span>
                </div>
            )}
        </>

    )
}


export default AfterBuy